import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import PopupTitle from '../../../components/common/popup_title';

const TooManyMealsErrorModal = ({ onDismiss }) => {
  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      onClose={() => {}}
      PaperProps={{
        style: {
          width: '260px',
          height: 'initial',
          maxHeight: 'initial',
          padding: '8px 16px',
        },
      }}>
      <PopupTitle
        titleText={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', margin: 'auto' }}>
              <WarningIcon
                style={{
                  color: 'orange',
                }}
              />
              <div style={{ margin: 'auto 0' }}>Too many meals selected</div>
            </div>
          </div>
        }
      />
      <div style={{ marginTop: '24px' }}>
        It looks like you’re adding quite a few meals at once. Please try adding
        them one at a time.
      </div>
      <Button
        variant="contained"
        color="primary"
        style={{ margin: '24px 6px 6px' }}
        onClick={onDismiss}>
        OK
      </Button>
    </Dialog>
  );
};

TooManyMealsErrorModal.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default TooManyMealsErrorModal;
